const Home = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Welcome to Medical Association of Andhra Pradesh</h1>
      <p className="text-lg mb-4">
        Serving the medical community of Andhra Pradesh and working towards better healthcare.
      </p>
    </div>
  );
};

export default Home; 